import createIcon from '../../createIcon';

/**
 * @component @name Elevenmp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiAxOC41SDEwLjVWMTRIOS41VjE3SDhWMTRIN1YxOC41SDUuNVYxMy41QzUuNSAxMi45NSA1Ljk1IDEyLjUgNi41IDEyLjVIMTFDMTEuNTUgMTIuNSAxMiAxMi45NSAxMiAxMy41VjE4LjVaTTE1LjUgMTguNUgxNFYxMi41SDE3LjVDMTguMDUgMTIuNSAxOC41IDEyLjk1IDE4LjUgMTMuNVYxNkMxOC41IDE2LjU1IDE4LjA1IDE3IDE3LjUgMTdIMTUuNVYxOC41Wk0xMSA1LjVWMTEuNUg5LjVWN0g4VjUuNUgxMVpNMTYgNS41VjExLjVIMTQuNVY3SDEzVjUuNUgxNlpNMTUuNSAxNEgxN1YxNS41SDE1LjVWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Elevenmp = createIcon('Elevenmp', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18.5H10.5V14H9.5V17H8V14H7V18.5H5.5V13.5C5.5 12.95 5.95 12.5 6.5 12.5H11C11.55 12.5 12 12.95 12 13.5V18.5ZM15.5 18.5H14V12.5H17.5C18.05 12.5 18.5 12.95 18.5 13.5V16C18.5 16.55 18.05 17 17.5 17H15.5V18.5ZM11 5.5V11.5H9.5V7H8V5.5H11ZM16 5.5V11.5H14.5V7H13V5.5H16ZM15.5 14H17V15.5H15.5V14Z',
      key: 'rd15n7',
    },
  ],
]);

export default Elevenmp;
